import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/UI/Button';

function PopUp({ children, icon, textButton })
{
    const [showPopper, setShowPopper] = useState(false);

    return (
        <>
            <Button
                icon={icon}
                margin="tw-mt-2 tw-py-0 tw-px-0 tw-mx-0"
                type="custom"
                padding="tw-px-0"
                customBg="tw-bg-transparent tw-text-primary-default hover:tw-text-primary-hover"
                className="tw-self-center"
                iconClassName="tw-mr-0"
                onClick={() => setShowPopper(true)}
            >
                {textButton}
            </Button>
            {showPopper && (
                <div
                    className="tw-z-[900] tw-bg-ivory-background dark:tw-bg-neutral-800 dark:tw-text-gray-100 tw-font-default tw-p-2"
                    onMouseLeave={() => setShowPopper(false)}
                >
                    {children}
                </div>
            )}
        </>
    );
};

PopUp.propTypes = {
    children: PropTypes.node,
    textButton: PropTypes.string,
    icon: PropTypes.object,
};

export default PopUp;
